import React, { useState } from 'react';
import TabBar from '../../component/tab-bar/tab-bar';
import HomeTab from './tabs/Home.tab';
import DocsTab from './tabs/Docs.tab';
import ExamTab from './tabs/Exam.tab';
import MissingReportsHoursTab from './tabs/MissingReportsHours.tab';
import { observer } from 'mobx-react-lite';

const tabs = ['כללי' /*, 'מסמכים', 'מבחנים', 'שעות עבודה'*/];

const pages = [
  <HomeTab />,
  <DocsTab />,
  <ExamTab />,
  <MissingReportsHoursTab />,
];

const HomePage = observer(() => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div
      style={{
        width: '100%',
        marginTop: '40px',
      }}
    >
      <div
        style={{
          color: '#041E49',
          fontSize: '30px',
          fontWeight: 'bold',
          marginTop: '20px',
          marginBottom: '20px',
        }}
      >
        דף הבית
      </div>
      <TabBar
        tabs={tabs}
        onClick={(index) => {
          setSelectedIndex(index);
        }}
      ></TabBar>

      <div style={{ marginTop: '20px' }}>{pages[selectedIndex]}</div>
    </div>
  );
});

export default HomePage;
